// src/components/home/Hero.jsx
import React from 'react';
import { ArrowRight, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../ui/Button';
import { BUSINESS_INFO } from '../../utils/constants';
import WhatsAppIcon from '../ui/WhatsAppIcon';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-bg">
        <img
          src="/assets/images/hero/hero.webp"
          alt="Premium mobile car valeting service"
          className="hero-bg-desktop"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <img
          src="/assets/images/hero/hero-mobile.jpg"
          alt="Premium mobile car valeting service"
          className="hero-bg-mobile"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-eyebrow animate-fade-in">
            <span className="hero-eyebrow-dot"></span>
            Premium Mobile Valeting
          </div>

          <h1 className="animate-fade-up">
            Luxury Shine,
            <span className="hero-gradient-text">Delivered to Your Doorstep & Workplace</span>
          </h1>

          <p className="animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Professional mobile car valeting across Sheffield & surrounding areas.
            We bring the equipment, products and expertise directly to your door.
          </p>

          <div className="hero-buttons animate-fade-up" style={{ animationDelay: '0.2s' }}>
            <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" size="lg" icon={WhatsAppIcon}>
                Book on WhatsApp
              </Button>
            </a>
            <Link to="/services">
              <Button variant="secondary" size="lg">
                View Services
                <ArrowRight size={18} />
              </Button>
            </Link>
          </div>

          <div className="hero-trust animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <div className="hero-trust-item">
              <div className="hero-trust-value">
                <span className="hero-stars">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} fill="var(--gold)" color="var(--gold)" />
                  ))}
                </span>
                4.9
              </div>
              <div className="hero-trust-label">Average Rating</div>
            </div>
            <div className="hero-trust-item">
              <div className="hero-trust-value">100+</div>
              <div className="hero-trust-label">Happy Clients</div>
            </div>
            <div className="hero-trust-item">
              <div className="hero-trust-value">100%</div>
              <div className="hero-trust-label">Mobile Service</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;